import React, { FunctionComponent } from 'react'

import { BadgeVariant } from '../../badge/constants'
import { TextBadge, type TextBadgeProps } from '../icons/TextBadge'

export type FieldBadgeProps = TextBadgeProps & { selected?: boolean }

/**
 * Badge used on in fields of form elements (such as Radio Buttons and Checkboxes)
 */
export const FieldBadge: FunctionComponent<FieldBadgeProps> = ({
  selected,
  variant = BadgeVariant.INFO_PRIMARY,
  bold = true,
  ...rest
}) => {
  return <TextBadge {...rest} variant={selected ? BadgeVariant.INVERSE : variant} bold={bold} />
}
